module.exports = __webpack_public_path__ + "img/vertical_6_7_6005.47ecc29b.png";